<template>
  <EuiDialog  :open="isOpen" size="small" @onClose="$emit('close-dialog')">
    <template v-slot:header>Confirmation</template>
    <EuiHeading :level="4">
        <span>
          <slot></slot>
        </span>
    </EuiHeading>
    <template v-slot:footer>
      <EuiButton color="primary" @click="$emit('close-dialog')">Annuler</EuiButton>
      <EuiButton
          color="primary"
          variant="raised"
          @click="$emit('confirmation')">
        Confirmer
      </EuiButton>
    </template>
  </EuiDialog>
</template>

<script>

/*
This component displays the confirmation modal
 */
export default {
  name: 'components.confirmationDialog',
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
